export function formatTimestamp(
  value: string | Date | null | undefined,
  locale: string = "pt-PT",
  options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }
): string {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(locale, options).format(date);
}